import { home } from '@project/api/home/v1'
import { page as contactUsPage } from '@project/api/contact-us/v1'
import { gtfsMap, agencies, routes, htaRoutes } from '@project/api/gtfs/v1'
import { calpolyDates } from '@project/api/calpoly/v1'
import { navAndFooter } from '@project/api/nav-and-footer/v1'
import { page as agencyPage } from '@project/api/agency-page/v1' 
import { page as htaPage } from '@project/api/hta-page/v1'
import { page as purchaseOnline } from '@project/api/purchase-online/v1'
import { page as farePage } from '@project/api/fare-page/v1'
import { page as holidayPage, holidays } from '@project/api/holidays/v1'
import { page as dialARidePage } from '@project/api/dial-a-ride/v1'
import { page as rideHumboldtFlexPage } from '@project/api/ride-humboldt-flex/v1'
import { paginate as paginateBoardMeetings, total as totalBoardMeetings, page as boardMeetingPage } from '@project/api/board-meetings/v1'
import { paginate as paginateNews, total as totalNews, page as newsPage, newsStory } from '@project/api/news/v1'

import { KitColor } from '@kit/utils/Colors'
import { AriaColor } from '@kit/utils/aria/AriaColors'

export default {
  async home() {
    return await home()
  },
  async contactUs() {
    return await contactUsPage()
  },
  async gtfsMap() {
    return await gtfsMap()
  },
  async agencies() {
    return await agencies()
  },
  async routes() {
    const rArr = await routes()

    //add some aria-adjusted colors
    for(let i=0; i<rArr.length; i++) {

      const route = rArr[i]
      const { color, text_color } = route

        let tColor = text_color
        let bColor = color
    
          if (tColor == "#") {
            tColor = "#000000";
          } 

          //Finally, wash all of the route colors through the AriaColor toolkit
          //to ensure proper contrast
          bColor = AriaColor.seekContrast(
            5,//4.5,
            KitColor.fromCSS(bColor),
            KitColor.fromCSS(tColor),
            2
          ).background.css();

        route["aria_text_color"] = tColor 
        route["aria_color"] = bColor
    }

    return rArr

  },
  async htaRoutes() {
    return await htaRoutes()
  },
  async navAndFooter() {
    return await navAndFooter()
  },
  async agencyPage(urlSlug) {
    return await agencyPage(urlSlug)
  },
  async holidays() {
    return await holidays()
  },
  async holidayPage() {
    return await holidayPage()
  },
  async htaPage({ section, slug}) {
    return await htaPage({section, slug})
  },
  async boardMeetings({ page, numberPerPage, sortField, sortCast, sortDirection }) {
    return await paginateBoardMeetings(sortField, sortCast, sortDirection, page, numberPerPage)
  },
  async totalBoardMeetings() {
    return await totalBoardMeetings()
  },
  async boardMeetingPage() {
    return await boardMeetingPage()
  },
  async news({ page, numberPerPage, sortField, sortCast, sortDirection }) {
    return await paginateNews(sortField, sortCast, sortDirection, page, numberPerPage)
  },
  async totalNews() {
    return await totalNews()
  },
  async newsPage() {
    return await newsPage()
  },
  async newsStory(urlSlug) {
    return await newsStory(urlSlug)
  },
  async purchaseOnline() {
    return await purchaseOnline()
  },
  async farePage() {
    return await farePage()
  },
  async dialARidePage() {
    return await dialARidePage()
  },
  async rideHumboldtFlexPage() {
    return await rideHumboldtFlexPage()
  },
  async calpolyDates() {
    return await calpolyDates()
  }
}

